export const domain = "https://interfaces.dev";
export const discordInviteUrl = "https://discord.gg/8ZWdj9emkA";
export const supportEmail = "jakub@kbo.sk";
export const siteName = "Interfaces › Design Engineering Magazine";
export const siteDescription =
  "Interfaces is a design engineering magazine about building great interfaces that covers topics such as animation, typography, layout and color.";
export const twitterHandle = "@jakubkrehel";
export const skillsRegistryUrl = "https://skills.sh/jakubkrehel/skills";
export const skillsRepoUrl = "https://github.com/jakubkrehel/skills";
export const NEWSLETTER_SUBSCRIBER_COUNT = 2624;
